import { ExpandMore } from '@mui/icons-material'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import ReactPlayer from 'react-player'
import React, { useState } from 'react'

interface Props {
  pitchDeckUrl?: string
  videoUrl?: string
}

const StartupAssetsSection = (props: Props) => {
  const [videoOpen, setVideoOpen] = useState(true)
  const [deckOpen, setDeckOpen] = useState(true)

  return (
    <Box sx={{
      border: 1,
      borderColor: 'text.secondary',
      borderRadius: '16px',
      backgroundColor: '#fff'
    }}
    display='flex'
    flexDirection='column'
    >

      <Accordion expanded={deckOpen} onChange={() => { setDeckOpen(!deckOpen) }}>
        <AccordionSummary 
          expandIcon={<ExpandMore />} 
          aria-controls='panel-deck-content' 
          id='panel-deck-header'>
            <Typography variant='body1'>
              Pitch Deck
            </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {props.pitchDeckUrl &&
            <object data={props.pitchDeckUrl} type="application/pdf" style={{
              width: '100%',
              minHeight: '500px'
            }}>
              <div>No online PDF viewer installed</div>
            </object>
          }
          {!props.pitchDeckUrl &&
            <Typography variant='body1' sx={{
              fontStyle: 'italic'
            }}>
              No pitch deck has been uploaded for this startup.
            </Typography>
          }
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={videoOpen} onChange={() => { setVideoOpen(!videoOpen) }}>
        <AccordionSummary 
          expandIcon={<ExpandMore />} 
          aria-controls='panel-video-content'
          id='panel-video-header'>
            <Typography variant='body1'>
              Video
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {props.videoUrl &&
              <ReactPlayer url={props.videoUrl} style={{
                width: '100%'
              }} />
            }
            {!props.videoUrl &&
              <Typography variant='body1' sx={{
                fontStyle: 'italic'
              }}>
                No video available
              </Typography>
            }
          </AccordionDetails>
      </Accordion>

    </Box>
  )
}

export default StartupAssetsSection
